export default __webpack_public_path__ + "static/media/gw.11ea6cf1.svg";